// DSS Documentation on SocoAlertComponent - http://tiny.sc/cgsocoalertcomponent
// DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SocoAlertLocation, SocoAlertService, SocoAlertServiceOptions, SocoAlertType } from '@app/soco/alert/soco-alert.service';

@Component({
    selector: 'soco-alert',
    // tslint:disable-next-line:max-line-length
    template: '<div id="{{alertId}}" class="soco-alert alert collapse" [ngClass]="alertType"><i class="soco-alert-icon" [ngClass]="alertIcon"></i><i class="fa-close close" (click)="hide()"></i><div class="message" [innerHtml]="message"></div></div>'
})
export class SocoAlertComponent implements OnInit {
    @Input() alertId: string = null;
    @Input() location: string = SocoAlertLocation[SocoAlertLocation.Page];
    message: SafeHtml = 'Message';
    alertIcon = 'fa-exclamation-circle';
    alertType = 'alert-danger';

    // DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
    constructor(private socoAlertService: SocoAlertService, private sanitizer: DomSanitizer) {
        socoAlertService.alertShown$.subscribe(options => {
            this.show(options);
        });
        socoAlertService.alertHidden$.subscribe(options => {
            this.hide();
        });
    }

    ngOnInit(): void {
        if (!this.alertId) {
            // DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
            this.alertId = this.socoAlertService.getDefaultAlertId();
        }
    }

    hide(): void {
        $('body').removeAttr('style');
        $('#' + this.alertId).hide().removeClass('soco-alert-system');
    }

    // DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
    private show(options: SocoAlertServiceOptions): void {
        // check if this alert should show or if the message is for some other alert
        if (options.id !== null && options.id !== this.alertId) {
            return;
        }

        // set the message and alert type
        this.message = this.sanitizer.bypassSecurityTrustHtml(options.message);
        switch (options.type) {
            case SocoAlertType.Success:
                this.alertType = 'alert-success';
                this.alertIcon = 'fa-check-circle';
                break;
            case SocoAlertType.Information:
                this.alertType = 'alert-info';
                this.alertIcon = 'fa-info-circle';
                break;
            case SocoAlertType.Caution:
                this.alertType = 'alert-warning';
                this.alertIcon = 'fa-exclamation-triangle';
                break;
            case SocoAlertType.Error:
                this.alertType = 'alert-danger';
                this.alertIcon = 'fa-times-circle';
                break;
            case SocoAlertType.Failure:
            default:
                this.alertType = 'alert-danger';
                this.alertIcon = 'fa-exclamation-circle';
                break;
        }

        // show the alert
        const alert = $('#' + this.alertId);
        alert.show();

        // if we are showing a system wide notification we need to shift content down
        if (options.location === SocoAlertLocation.System || SocoAlertLocation[this.location] === SocoAlertLocation.System) {
            alert.addClass('soco-alert-system');
            $('body').css('padding-top', alert.outerHeight());
        }
    }
}
